import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import './AspectRatioImage.less';

export default function AspectRatioImage({className, children}) {
    return (
        <div className={classNames('AspectRatioImage', className)}>
            <div className="AspectRatioImage__figure-perspective-wrapper">
                <div className="AspectRatioImage__figure image-hover-element">
                    <div className="AspectRatioImage__image">{children}</div>
                </div>
            </div>
        </div>
    );
}

AspectRatioImage.propTypes = {
    className: PropTypes.string,
};
